import { render, staticRenderFns } from "./RecuperarContrasena.vue?vue&type=template&id=af1fc032"
import script from "./RecuperarContrasena.vue?vue&type=script&lang=js"
export * from "./RecuperarContrasena.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports